
import React from 'react';

// Hero Section
export const HERO_HEADLINE = "สัมภาษณ์ด้วยระบบ AI";
export const HERO_HEADLINE_SMALL = "ทดลองสัมภาษณ์งานเป็นภาษาอังกฤษ มีโอกาสในการได้งานสูงถึง 40% (สถิติจาก ScoutOut Analyzer) พร้อมให้คุณได้ฝึกแล้ววันนี้";
export const HERO_SUBHEADLINE = "หยุดเดาสุ่ม เริ่มเตรียมตัว รับผลตอบรับทันทีที่นำไปใช้ได้จริงเกี่ยวกับทักษะการสัมภาษณ์ของคุณด้วย AI อัจฉริยะของเรา ฝึกซ้อมสถานการณ์เสมือนจริงได้ทุกที่ทุกเวลา และสร้างความมั่นใจที่ไม่มีวันสั่นคลอน";
export const HERO_CTA_PRIMARY = "เริ่มฝึกสัมภาษณ์แรกของคุณเลย";
export const HERO_TRUST_BADGE = "เข้าร่วม Ecosystem ของเรา ที่ซึ่งผู้มีความสามารถกว่า 3,000,000 คน ได้เชื่อมต่อกับบริษัทกว่า 40,000 แห่ง เพื่อเติบโตและประสบความสำเร็จไปด้วยกัน";

// Hero Form
export const HERO_FORM_TITLE = "สัมภาษณ์งานออนไลน์ด้วยระบบ AI";
export const HERO_FORM_SUBTITLE = "ระบบสัมภาษณ์งานออนไลน์ที่ใช้เทคโนโลยี AI เพื่อเพิ่มประสิทธิภาพและประหยัดเวลาในกระบวนการสรรหาบุคลากร";
export const HERO_FORM_JOB_POSITION_LABEL = "ระบุตำแหน่งงาน";
export const HERO_FORM_JOB_POSITION_PLACEHOLDER = "เช่น วิศวกรซอฟต์แวร์, ผู้จัดการฝ่ายการตลาด";
export const HERO_FORM_JOB_TYPE_LABEL = "ประเภทงาน";
export const HERO_FORM_JOB_TYPE_PLACEHOLDER = "เลือกประเภทงาน";
export const HERO_FORM_EXP_LABEL = "ประสบการณ์";
export const HERO_FORM_EXP_PLACEHOLDER = "เลือกประสบการณ์";
export const HERO_FORM_UPLOAD_RESUME_LABEL = "อัปโหลด Resume ของคุณ (Upload resume)";
export const HERO_FORM_UPLOAD_RESUME_BUTTON_TEXT = "อัปโหลดเรซูเม่";
export const HERO_FORM_FILE_UPLOAD_HELPER_TEXT = "อัปโหลดเรซูเม่ของคุณเป็นไฟล์ .pdf, .docx, .jpeg หรือ .png ขนาดไม่เกิน 20MB";
export const HERO_FORM_TERMS_AGREEMENT_TEXT_PART1 = "เมื่อกดปุ่ม 'เริ่มสัมภาษณ์' ถือว่าฉันได้อ่านและยอมรับ";
export const HERO_FORM_TERMS_LINK_TEXT = "ข้อกำหนด/เงื่อนไขการใช้งาน";
export const HERO_FORM_PRIVACY_LINK_TEXT = "นโยบายความเป็นส่วนตัว";
export const HERO_FORM_START_INTERVIEW_BUTTON_TEXT = "เริ่มสัมภาษณ์";


// ProblemSolution Section
export const PROBLEM_HEADLINE = "เบื่อไหมกับอาการประหม่าตอนสัมภาษณ์ & ไม่รู้จะเตรียมตัวอย่างไร?";
export const PAIN_POINT_1_TITLE = "ขาดการฝึกซ้อมที่สมจริง";
export const PAIN_POINT_1_DESC = "หาคนช่วยซ้อมสัมภาษณ์ด้วยยากใช่ไหม? คำถามทั่วไปออนไลน์ก็ไม่ตอบโจทย์";
export const PAIN_POINT_2_TITLE = "ไม่มีผลตอบรับที่เป็นกลาง";
export const PAIN_POINT_2_DESC = "เพื่อนและครอบครัวหวังดี แต่คำแนะนำของพวกเขาอาจไม่ใช่สิ่งที่คุณต้องการจริงๆ คุณพูดได้ดีแค่ไหนกันแน่?";
export const PAIN_POINT_3_TITLE = "ความวิตกกังวลและความมั่นใจต่ำ";
export const PAIN_POINT_3_DESC = "ความกลัวในสิ่งที่ไม่รู้สามารถทำให้คุณเป็นอัมพาตได้ การรู้สึกไม่พร้อมนำไปสู่การพลาดโอกาส";
export const PAIN_POINT_4_TITLE = "เสียเวลาโดยเปล่าประโยชน์";
export const PAIN_POINT_4_DESC = "ค้นหาเคล็ดลับไม่รู้จบโดยไม่มีการฝึกฝนที่เป็นระบบ";
export const SOLUTION_INTRO = "ขอแนะนำ AI สัมภาษณ์งาน: โค้ชสัมภาษณ์ส่วนตัวของคุณ พร้อมให้บริการ 24/7";

export const HOW_IT_WORKS_STEP_1_TITLE = "เลือกประเภทการสัมภาษณ์";
export const HOW_IT_WORKS_STEP_1_DESC = "เลือกจากประเภทการสัมภาษณ์ทั่วไป (พฤติกรรม, เทคนิค, ทั่วไป) หรือปรับแต่งสำหรับตำแหน่งงานเฉพาะ";
export const HOW_IT_WORKS_STEP_2_TITLE = "ฝึกซ้อมกับ AI";
export const HOW_IT_WORKS_STEP_2_DESC = "เข้าร่วมการจำลองการสัมภาษณ์แบบโต้ตอบเสมือนจริงกับ AI สัมภาษณ์อัจฉริยะของเรา";
export const HOW_IT_WORKS_STEP_3_TITLE = "รับผลตอบรับทันที";
export const HOW_IT_WORKS_STEP_3_DESC = "รับข้อมูลเชิงลึกที่นำไปปฏิบัติได้จริงเกี่ยวกับคำตอบ, การนำเสนอ, ความชัดเจน และแม้กระทั่งภาษากาย (หากเปิดใช้งานวิดีโอ)";
export const HOW_IT_WORKS_STEP_4_TITLE = "ปรับปรุงและพัฒนา";
export const HOW_IT_WORKS_STEP_4_DESC = "ระบุจุดอ่อน, ปรับปรุงคำตอบของคุณ, และติดตามความคืบหน้าเมื่อเวลาผ่านไป";
export const PROBLEM_CTA_SECONDARY = "ดูวิธีการทำงาน";

// Features Section
export const FEATURES_HEADLINE = "ปลดล็อกศักยภาพการสัมภาษณ์เต็มรูปแบบของคุณด้วยคุณสมบัติทรงพลัง";
export const FEATURE_1_TITLE = "การจำลองการสัมภาษณ์ด้วย AI ที่สมจริง";
export const FEATURE_1_BENEFIT = "ฝึกฝนในสภาพแวดล้อมที่ปราศจากแรงกดดันและสมจริง AI ของเราจะถามคำถามที่เกี่ยวข้องเหมือนผู้สัมภาษณ์จริง ช่วยให้คุณคุ้นเคยและลดความวิตกกังวล";
export const FEATURE_2_TITLE = "ผลตอบรับทันทีที่นำไปปรับใช้ได้จริง";
export const FEATURE_2_BENEFIT = "ไม่ต้องเดาอีกต่อไป! รับรายงานละเอียดทันทีเกี่ยวกับโครงสร้างคำตอบ, ความชัดเจน, การใช้คีย์เวิร์ด, จังหวะการพูด, และความมั่นใจ รู้ว่าต้องปรับปรุงตรงไหน";
export const FEATURE_3_TITLE = "เส้นทางการฝึกซ้อมที่ปรับให้เหมาะกับคุณ";
export const FEATURE_3_BENEFIT = "ปรับการฝึกซ้อมให้ตรงจุด เน้นประเภทคำถามเฉพาะ (วิธี STAR, พฤติกรรม, ความท้าทายทางเทคนิค) หรืออุตสาหกรรม AI จะปรับตามความต้องการของคุณ";
export const FEATURE_4_TITLE = "การติดตามความมั่นใจและประสิทธิภาพ";
export const FEATURE_4_BENEFIT = "เฝ้าดูทักษะของคุณเติบโต! เห็นพัฒนาการของคุณเมื่อเวลาผ่านไปด้วยรายงานความคืบหน้า, สร้างความอดทนในการสัมภาษณ์, และเดินเข้าห้องสัมภาษณ์จริงด้วยความมั่นใจเต็มเปี่ยม";
export const FEATURE_5_TITLE = "คลังคำถามและแนวคำตอบ";
export const FEATURE_5_BENEFIT = "เข้าถึงคลังคำถามสัมภาษณ์ที่พบบ่อยและท้าทายมากมาย พร้อมเคล็ดลับจากผู้เชี่ยวชาญและตัวอย่างคำตอบเพื่อเป็นแรงบันดาลใจ";

// Testimonials Section
export const TESTIMONIALS_HEADLINE = "เข้าร่วมกับผู้คนนับพันที่ได้งานในฝัน!";
export const TESTIMONIAL_1_QUOTE = "AI สัมภาษณ์งานเปลี่ยนเกมเลย! ผลตอบรับช่วยให้ฉันรู้จุดที่ต้องแก้ไขจริงๆ ฉันได้งานในฝันเมื่อสัปดาห์ที่แล้ว!";
export const TESTIMONIAL_1_NAME = "ซาร่า เอ็ม.";
export const TESTIMONIAL_1_TITLE = "วิศวกรซอฟต์แวร์";
export const TESTIMONIAL_2_QUOTE = "เมื่อก่อนฉันกลัวการสัมภาษณ์มาก การฝึกกับ AI ทำให้ฉันมั่นใจและพูดได้คล่องขึ้นเยอะ";
export const TESTIMONIAL_2_NAME = "จอห์น บี.";
export const TESTIMONIAL_2_TITLE = "ผู้จัดการฝ่ายการตลาด";
export const CREDIBILITY_BOOSTER_1 = "ได้รับการกล่าวถึงใน TechCrunch, Forbes";
export const FINAL_VALUE_PROPOSITION = "หยุดปล่อยให้ความสำเร็จในการสัมภาษณ์เป็นเรื่องของโชค ลงทุนเพื่ออนาคตของคุณ, สร้างความได้เปรียบในการแข่งขัน, และเดินเข้าสู่การสัมภาษณ์ครั้งต่อไปด้วยความพร้อมและความมั่นใจเต็มร้อย";
export const FINAL_CTA = "เริ่มฝึกซ้อม & พิชิตการสัมภาษณ์ของคุณ!";
export const FAQ_1_QUESTION = "เริ่มต้นใช้งานฟรีจริงหรือ?";
export const FAQ_1_ANSWER = "ใช่! คุณสามารถเริ่มฝึกซ้อมการสัมภาษณ์แรกของคุณได้ฟรี เพื่อสัมผัสประสบการณ์และคุณสมบัติหลักของเรา";
export const FAQ_2_QUESTION = "ฉันจะได้รับผลตอบรับประเภทใดบ้าง?";
export const FAQ_2_ANSWER = "AI ของเราจะให้ผลตอบรับครอบคลุมหลายด้าน เช่น ความชัดเจนของคำตอบ, การใช้คำสำคัญ, ความเร็วในการพูด, ความมั่นใจ, และโครงสร้างคำตอบตามหลัก STAR";

// Navbar
export const NAVBAR_LOGO_TEXT = "Interview AI";

// Footer
export const FOOTER_TEXT = `© ${new Date().getFullYear()} Interview AI. สงวนลิขสิทธิ์.`;
